<template>
  <div
    class="d-flex mb-2 justify-content-center align-items-center"
  >
    <b-overlay
      id="overlay"
      :show="isLoading"
      spinner-variant="secondary"
      height="120"
      opacity="1"
      rounded="sm"
      bg-color="#FEFCFC"
      class="custom-overlay d-flex align-items-center"
    >
      <!-- if don't have timeslots-->
      <b-col
        v-if="!getDayTimeslots.length && !isLoading"
        class="text-center"
      >
        {{ i18n.t('all-timeslots-are-booked-up-for-day', getLanguage) }}
      </b-col>
      <div
        v-if="!isLoading"
        class="d-flex justify-content-center flex-wrap pl-1 pr-1 pt-1"
      >
        <span
          v-for="(timeslot, i) in getDayTimeslots"
          :key="i"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            class="timeslot-button queue-button buttons-effect"
            size="sm"
            :style="`border: 1px solid ${getWidgetSettings.main_color} !important; color: ${getWidgetSettings.main_color}`"
            @click="showModal(timeslot, date)"
          >
            {{ timeslot.slice(0,5) }}
          </b-button><br v-if="(i % 8) === 7">
        </span>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { BOverlay, BButton, BCol } from 'bootstrap-vue'
import { getFormattedDateForBackend } from '@/libs/utils'
import i18n from '@/libs/i18n';

export default {
  name: 'Timeslots',
  directives: {
    Ripple,
  },
  components: {
    BOverlay,
    BButton,
    BCol,
  },
  props: {
    selectedDate: {
      type: Date,
      default: () => new Date(),
    },
    workspace: {
      type: String,
      required: true,
    },
    service: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      date: getFormattedDateForBackend(this.selectedDate),
      services: [],
      isLoading: false,
      i18n,
    }
  },
  computed: mapGetters(['getWidgetSettings', 'getLanguage', 'getDayTimeslots']),
  watch: {
    selectedDate(newDate) {
      this.date = getFormattedDateForBackend(newDate)
    },
  },
  methods: {
    setLoading(value) {
      this.isLoading = value
    },
    showModal(start, date) {
      this.$emit('openModal', { timeslot: start, day: date })
    },
  },
}
</script>

<style scoped>

</style>
